import type { Mutation } from 'vuex'
import type { HandleFlag, State } from './state'
import type { BulkRevisionSendEditTableItem, BulkRevisionSendEditTableList } from '@/views/product/BulkRevisionSendEdit/types'

import actionTypes from './actionTypes'

const mutations: { [actionTypes: string]: Mutation<State> } = {
  // 一括改版送信（編集）画面 メッセージ
  [actionTypes.SET_MESSAGE]: (state: State, message: string): void => {
    state.bulkRevisionSendEditDisplayItem.message = message
  },

  // 一括改版送信（編集）画面 メッセージのエラー内容
  [actionTypes.SET_MESSAGE_ERROR]: (state: State, errorMessage: string): void => {
    state.bulkRevisionSendEditDisplayItem.messageError = errorMessage
  },

  //  一括改版送信（編集）画面 テーブルリスト
  [actionTypes.SET_TABLE_LIST]: (
    state: State,
    tableList: BulkRevisionSendEditTableList
  ): void => {
    state.bulkRevisionSendEditTableList = tableList
  },

  //送信先変更か追加のフラグ
  [actionTypes.SET_HANDLE_FLAG]: (
    state: State,
    flag: HandleFlag
  ): void => {
    state.handleFlag = flag
  },

  //一括改版送信の編集画面で選択したデータ
  [actionTypes.SET_SELECTED_ITEM]: (
    state: State,
    selectedItem: BulkRevisionSendEditTableItem
  ): void => {
    state.selectedItem = selectedItem
  },
}

export default mutations
